const FeatureStatus = Object.freeze({
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  UNDEFINED: 'UNDEFINED',
});

export default FeatureStatus;
